import React, {Component, Fragment} from 'react';
import './ListAll.css';
import Moment from 'react-moment';
import 'moment/locale/fr';
import Parser from 'html-react-parser';
import { Link } from 'react-router-dom';

const articles = require('../res/recipes.json');

class ListAll extends Component {

    constructor(props) {
        super(props);
    }

    sortRecipesByDate(recipes) {
        return recipes.sort(function(a, b) {
            const titleA = a.date.toUpperCase();
            const titleB = b.date.toUpperCase();
            return (titleA > titleB) ? -1 : (titleA < titleB) ? 1 : 0;
        });
    }

    componentWillMount() {
        this.props.loadArticles(this.props.match.params.page);
    }

    shouldComponentUpdate(nextProps) {
        // if (nextProps.match.params.page > nextProps.totalPages) {
        //     nextProps.history.push('accueil/1');
        // } else if (nextProps.match.params.page !== this.props.match.params.page) {
        //     nextProps.loadArticles(nextProps.match.params.page);
        //     window.scrollTo(0, 0);
        //     return false;
        // }
        window.scrollTo(0, 0);
        return true;
    }

    componentWillUnmount() {
        this.props.clearArticles();
    }

    paginate(array, page_size, page_number) {
        // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
        return array.slice((page_number - 1) * page_size, page_number * page_size);
    }

    render() {
        const totalPages = Math.ceil(articles.length / 10);
        const page = parseInt(this.props.match.params.page);

        return (
            <div className="articles">
                { this.paginate(this.sortRecipesByDate(articles), 10, page).map(article =>
                    article.type === 'RECIPE' ?
                    <div key={article.label} className="home-article">
                        <Link to={`/recette/${article.label}`}
                              className="home-article--header" >
                               {article.title}
                        </Link>
                        <div className="home-article--content">
                            <div className="article-content__picture">
                                <Link to={`/recette/${article.label}`}>
                                    <img src={`/images/recipes/home_${article.picture}`} alt="picture" />
                                </Link>
                            </div>
                            <div className="article-content__ingredients">
                                <span className="article-content__ingredients-title">INGREDIENTS :</span>
                                <ul className="article-content__ingredients-list">
                                    {
                                        article.ingredients && article.ingredients.map(ingredient =>
                                            <li key={ingredient} className="article-content__ingredients-item"><i className="fa fa-asterisk"></i>&nbsp;{ingredient}</li>
                                        )
                                    }
                                    {
                                        article['ingredients-multiple'] && article['ingredients-multiple'][0].ingredients.map(ingredient =>
                                            <li key={ingredient} className="article-content__ingredients-item"><i className="fa fa-asterisk"></i>&nbsp;{ingredient}</li>
                                        )
                                    }
                                    {article['ingredients-multiple'] && (<span>...</span>)}
                                </ul>
                            </div>
                        </div>
                        <div className="home-article--infos">
                            <Link to={`/recette/${article.label}`} className="article-infos__more">
                                <i className="fa fa-plus-square"></i>&nbsp;
                                Voir la recette
                            </Link>
                            {/*<div className="article-infos__views">*/}
                            {/*    <i className="fa fa-eye"></i>&nbsp;*/}
                            {/*    {article.views} <span className="none">Vue(s)</span>*/}
                            {/*</div>*/}
                            {/*<div className="article-infos__comments">*/}
                            {/*    <i className="fa fa-comment"></i>&nbsp;*/}
                            {/*    {article.nbComments} <span className="none">Commentaire(s)</span>*/}
                            {/*</div>*/}
                        </div>
                        <div className="home-article--footer">
                            <i className="fa fa-calendar"></i>Publié le <Moment format="DD MMMM YYYY">{article.date}</Moment>
                        </div>
                    </div>
                    :
                    <div key={article.date} className="home-article">
                        <Link to={`/partenaire/${article.label}`}
                              className="home-article--header" >
                            {article.name}
                        </Link>
                        <div className="home-article--content">
                            <div className="article-content__picture">
                                <Link to={`/partenaire/${article.label}`}>
                                    <img src={`/images/partners/home_${article.picture}`} alt="picture" />
                                </Link>
                            </div>
                            <div className="article-content__ingredients">
                                <div>{Parser(article.introduction)}</div>
                            </div>
                        </div>
                        <div className="home-article--infos">
                            <Link to={`/partenaire/${article.label}`} className="article-infos__more">
                                <i className="fa fa-plus-square"></i>&nbsp;
                                Voir l'article
                            </Link>
                            <div className="article-infos__views">
                                <i className="fa fa-eye"></i>&nbsp;
                                {article.views} <span className="none">Vue(s)</span>
                            </div>
                            <div className="article-infos__comments">
                                <i className="fa fa-comment"></i>&nbsp;
                                {article.nbComments} <span className="none">Commentaire(s)</span>
                            </div>
                        </div>
                        <div className="home-article--footer">
                            <i className="fa fa-calendar"></i>Publié le <Moment format="DD MMMM YYYY">{article.date}</Moment>
                        </div>
                    </div>
                )}
                <div className="articles_pagination">
                    { page > 1 &&
                        <Link className="articles_pagination--left"
                              to={`/accueil/${page - 1}`}>
                            <i className="fa fa-arrow-circle-left"></i>
                            &nbsp; Page précédente
                        </Link>
                    }
                    {page < totalPages &&
                        <Link className="articles_pagination--right"
                              to={`/accueil/${page + 1}`}>
                            <div>
                                Page suivante &nbsp;
                                <i className="fa fa-arrow-circle-right"></i>
                            </div>
                        </Link>
                    }
                </div>
            </div>
        );
    }
}

export default ListAll;



// WEBPACK FOOTER //
// ./src/components/ListAll.js